export default __webpack_public_path__ + "static/media/reload.ae13088c.svg";